import React, { useState, useEffect } from "react";
import { StatusBar, Platform } from "react-native";
// import RNBootSplash from "react-native-bootsplash";
import { NavigationContainer } from "@react-navigation/native";

import AuthNavigator from "./app/navigation/AuthNavigator";
import navigationTheme from "./app/navigation/navigationTheme";

import AuthContext from "./app/auth/context";
import authStorage from "./app/auth/storage";
import { navigationRef } from "./app/navigation/rootNavigation";
import AppNavigator from "./app/navigation/AppNavigator";

const App: React.FC = () => {
  const [token, setToken] = useState();
  // const [userType, setUserType] = useState();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      // …do multiple sync or async tasks
      const token = await authStorage.getToken();
      // console.log(token, "dsl");
      if (token) setToken(token);
    };

    init().finally(async () => {
      // await RNBootSplash.hide({ fade: true });
      console.log("Bootsplash has been hidden successfully");
    });
  }, []);

  // const restoreToken = async () => {
  //   const token = await authStorage.getToken();

  //   // const imageAssets = cacheImages([
  //   //   require('./app/assets/city_landscape_small.jpg'),
  //   //   require('./app/assets/paris_portrait.jpg'),
  //   // ]);

  //   // await Promise.all([...imageAssets]);
  //   if (token) setToken(token);
  // };

  // if (!isReady)
  //   return (
  //     <AppLoading startAsync={restoreToken} onFinish={() => setIsReady(true)} />
  //   );

  return (
    // const App: () => React$Node = () => {
    //   return (
    <>
      <StatusBar barStyle="dark-content" />
      <AuthContext.Provider value={{ token, setToken }}>
        {/* <OfflineNotice /> */}

        <NavigationContainer ref={navigationRef} theme={navigationTheme}>
          {!token ? <AuthNavigator /> : <AppNavigator token={token} />}
        </NavigationContainer>
      </AuthContext.Provider>
    </>
  );
};

export default App;
